const messages = {
    footer: {
      phone: '@:header.phoneToCall'
    },
    header: {
      phoneToCall: '44.800.098.1496',
      contactPhone: '@:header.phoneToCall',
      contactPhoneTitle: '@:header.contactPhone',
      contactSubPhone: '@:header.phoneToCall',
      shortPhone: '+@:header.phoneToCall',
      navigationPhoneString: 'Call {link}',
      reservationPhoneString: '{phone}',
    }
  }
  export default messages
